import React, { type FC } from "react";
import type { ApiOmpBoAvOperation } from "@src/api/bo";
import { DetailList, DetailRow } from "@shared/ui/detail-row";
import "./BoOperationConfirmContent.scss";

export interface BoOperationConfirmField {
    label: string;
    value?: string | null;
}

export interface BoOperationConfirmContentProps {
    operation: ApiOmpBoAvOperation;
    documentLabel: string;
    fields: BoOperationConfirmField[];
}

/**
 * Domain-контент confirm для выполнения BO-операции.
 */
export const BoOperationConfirmContent: FC<BoOperationConfirmContentProps> = ({ operation, documentLabel, fields }) => {
    return (
        <div className="bo_operation_confirm_content">
            <DetailList.Card
                aria-label="Выбранная операция"
                label="Операция к выполнению"
                value={operation.Name}
                size="lg"
                tone="accent"
            />
            <section className="bo_operation_confirm_content__section" aria-labelledby="bo-operation-confirm-details-title">
                <h3 id="bo-operation-confirm-details-title" className="bo_operation_confirm_content__section_title">
                    Информация по документу
                </h3>
                <DetailList layout="tiles" columns="auto" minWidth={80} className="bo_operation_confirm_content__details">
                    <DetailRow label="Документ" value={documentLabel} />
                    {fields.map((row) => (
                        <DetailRow key={row.label} label={row.label} value={row.value ?? "—"} />
                    ))}
                </DetailList>
            </section>
        </div>
    );
};
